export default __webpack_public_path__ + "static/media/Acolyte's Robes of the Underworld.7500df6b.jpg";